import { Component, EventEmitter, HostBinding, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { FileUpload } from "primeng/fileupload";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
    selector: 'app-file-input',
    templateUrl: './file-input.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FileInputComponent,
            multi: true
        }
    ],
    styleUrls: ['./file-input.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FileInputComponent implements OnInit, ControlValueAccessor {
    @ViewChild('fileInput', {static: true}) fileInput: FileUpload;

    _hasError = false;

    @Input() files: File[] = [];
    @Input() multiple = true;
    @Input() acceptedTypes = 'media_type';
    @Input() required = true;

    @HostBinding('class.hidePreview') @Input() hidePreview = false;

    @Output() onFilesSelected: EventEmitter<any> = new EventEmitter();
    @Output() onFileRemoved: EventEmitter<any> = new EventEmitter();

    private onChangeCallback: (_: any) => {};
    private onTouchedCallback: (_: any) => {};

    constructor() {
    }

    ngOnInit() {
    }


    onSelect() {
        this._hasError = false;
        this.onFilesSelected.emit(this.fileInput.files);

        if (this.onChangeCallback) {
            this.onChangeCallback(this.fileInput.files);
        }
    }

    onRemove() {
        this._hasError = false;
        this.onFileRemoved.emit(this.fileInput.files);

        if (this.onChangeCallback) {
            this.onChangeCallback(this.fileInput.files);
        }
    }

    get hasError() {
        return this._hasError;
    }

    @Input()
    set hasError(hasError) {
        this._hasError = hasError;
    }

    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }

    writeValue(obj: any): void {
        this.files = obj ? obj : [];
    }


}
